import React, { useEffect, useState } from "react"
import { Form, Input, Button } from "antd"
import axios from "axios"

const ComplainAddress = () => {
  const [form] = Form.useForm()
  const [initialValues, setInitialValues] = useState({})
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [addressId, setAddressId] = useState(null)

  const adminId = localStorage.getItem("adminId")

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const bin = urlParams.get("bin")
    const boro = urlParams.get("boro")
    const stname = urlParams.get("stname")
    const lhnd = urlParams.get("lhnd")
    const block = urlParams.get("block")
    const lot = urlParams.get("lot")
    const correctingAddress = urlParams.get("correctingAddress")

    setInitialValues({
      bin,
      boro,
      stname,
      lhnd,
      block,
      lot,
    })

    setAddressId(correctingAddress)

    form.setFieldsValue({
      bin,
      boro,
      stname,
      lhnd,
      block,
      lot,
    })
  }, [form])

  const onFinish = async (values) => {
    try {
      setSubmitting(true)
      const response = await axios.post(
        "https://stonecore-2024.uc.r.appspot.com/v1/correctionRequests/create",
        {
          ...values,
          requester: adminId,
          correctingAddress: addressId,
        }
      )
      console.log("Success:", response.data)
      setIsSubmitted(true)
      setSubmitting(false)
    } catch (error) {
      console.error("Error:", error)
      setSubmitting(false)
    }
  }

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo)
  }

  return (
    <>
      {!isSubmitted ? (
        <Form
          form={form}
          name="basic"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          style={{
            maxWidth: 600,
          }}
          initialValues={initialValues}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Borough:"
            name="boro"
            rules={[
              {
                required: true,
                message: "Please input the borough!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="House Number:"
            name="lhnd"
            rules={[
              {
                required: true,
                message: "Please input the house number!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Address:"
            name="stname"
            rules={[
              {
                required: true,
                message: "Please input the address!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Block:"
            name="block"
            rules={[
              {
                required: true,
                message: "Please input the block!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Lot:"
            name="lot"
            rules={[
              {
                required: true,
                message: "Please input the lot!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Bin:"
            name="bin"
            rules={[
              {
                required: true,
                message: "Please input the bin!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Button disabled={submitting} type="primary" htmlType="submit">
              Submit Correction Request
            </Button>
          </Form.Item>
        </Form>
      ) : (
        <div>
          <h3>Thank you for submitting the correction form!</h3>
          <p>
            We have received your request to update your address information. We
            will review the details provided and verify the changes.
          </p>
          <p>
            We will get back to you at your registered email address once the
            update is processed.
          </p>
          <p>Thank you for helping us keep your information accurate.</p>
        </div>
      )}
    </>
  )
}

export default ComplainAddress

